import BaseApiService from './api.base.service'
export default class TsidApiService extends BaseApiService {
  constructor() {
    super('tsId')
  }

  getBasicUserInfo(tsId) {
    return this.callGet(`/users/info`, { tsid: tsId })
  }

  login(codeParam) {
    return this.callPost('/users/login', codeParam, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  receiveToken(codeParam) {
    return this.callPost('/users/token', codeParam, {
      headers: { 'Content-Type': 'application/json' },
    })
  }

  validateUser(tsId) {
    return this.callPost('/users/validate', tsId)
  }

  getTsIdData(codeParam) {
    return this.callPost('', codeParam, {
      headers: { 'Content-Type': 'application/json' },
    })
  }
}

export const tsidApi = new TsidApiService()
